import { type JSX } from 'react';

export const BadgePlaceholder = (): JSX.Element => {
  return (
    <svg
      fill="none"
      height="100%"
      style={{ display: 'block' }}
      viewBox="0 0 21 22"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M18.0426 8.86003C18.1161 7.58483 18.0284 5.67836 17.8031 4.34965C12.6066 1.96256 8.4908 1.96245 3.29748 4.34925C3.07078 5.69716 2.98384 7.59723 3.05743 8.87555C3.17145 10.8564 3.71692 12.727 4.81574 14.447C6.21241 16.6299 8.2088 18.3369 10.5493 19.3562C12.8903 18.3331 14.8858 16.6215 16.2798 14.4344L16.3387 14.342C17.4018 12.6443 17.9305 10.8045 18.0426 8.86003ZM10.55 20.5C7.8464 19.4242 5.53881 17.5108 3.94979 15.0272C1.26554 10.8255 2.03838 5.51808 2.33165 3.85506L2.37305 3.61849C8.23837 0.793835 12.8582 0.793835 18.7269 3.61849L18.7684 3.85506C19.0616 5.50043 19.8345 10.8079 17.1502 15.0096C15.5608 17.5013 13.2543 19.4198 10.55 20.5ZM4.23247 5.08868C8.74585 3.12834 12.3591 3.12855 16.8754 5.08944C17.0291 6.13583 17.068 7.83733 17.0127 8.79777C16.907 10.6306 16.4042 12.2797 15.4706 13.7706L15.4162 13.8558C14.2165 15.7381 12.5312 17.239 10.5519 18.1955C8.57302 17.2424 6.88697 15.7454 5.68502 13.8668C4.72043 12.3569 4.20151 10.6807 4.09403 8.81336C4.03846 7.84792 4.07718 6.1495 4.23247 5.08868Z"
        fill="#042E4A"
        fillRule="evenodd"
      />
    </svg>
  );
};
